<template>
    <div>
        <div class="row">
            <div class="form-group col-12">
                <label>Status</label>

                <v-select
                    v-model="item.status"
                    :options="['published', 'draft']"
                    :clearable="false"
                />
            </div>

            <form-input
                v-model="item.name"
                label="Name"
                :error-message="getError('name')"
                placeholder="Name"
                @blur="$emit('on-name-change', item.name)"
            />

            <form-input
                v-model="item.description"
                label="Description"
                placeholder="Description"
            />

            <div
                class="form-group col-12"
                style="display: flex; flex-direction: column"
            >
                <label> Date </label>
                <date-picker v-model="item.date" value-type="YYYY-MM-DD" />
            </div>

            <div class="form-group col-12 mt-3">
                <b-form-checkbox v-model="addExternalLink" switch>
                    Add external link
                </b-form-checkbox>
            </div>

            <form-input
                v-if="addExternalLink"
                v-model="item.externalLink"
                label="External Link"
                placeholder="https://www.google.com"
            />

            <div v-else class="form-group col-12">
                <label>Assign Article</label>

                <articles-chooser
                    :value="articleChooserValue"
                    :max-articles-count="1"
                    :filters="articleFilters"
                    @on-articles-change="onArticleSelected"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import BaseForm from '@/components/elements/BaseForm';
import { ArticleType, ArticleStatus } from '@/enums/articles';
import ArticlesChooser from '@/components/elements/ArticlesChooser';

export default {
    components: {
        DatePicker,
        ArticlesChooser
    },

    extends: BaseForm,

    data() {
        return {
            addExternalLink: false,
            selectedArticle: null
        };
    },

    computed: {
        articleChooserValue() {
            return this.selectedArticle ? [this.selectedArticle] : [];
        },

        articleFilters() {
            const language = this.value.language;

            return {
                'language.code': {
                    value: language?.code || null,
                    type: 'eq'
                },
                type: {
                    type: 'eq',
                    value: ArticleType.EVENT
                },
                status: { value: ArticleStatus.PUBLISHED, type: 'eq' }
            };
        }
    },

    watch: {
        addExternalLink() {
            this.item.externalLink = null;
            this.item.articleId = null;
            this.selectedArticle = null;
        },

        watch: {
            'value.language'() {
                this.item.language = this.value.language;
            }
        }
    },

    created() {
        this.selectedArticle = this.value?.article || null;
    },

    methods: {
        onArticleSelected(articles) {
            if (articles.length) {
                this.item.articleId = articles[0].id;
                this.selectedArticle = articles[0];
            } else {
                this.item.articleId = null;
                this.selectedArticle = null;
            }
        }
    }
};
</script>
